/* ============================================================
   DBYZ — Pages JavaScript
   PATH: assets/dbyz-pages.js
   HOW TO LOAD: In layout/theme.liquid, just before </body>:
   <script src="{{ 'dbyz-pages.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  /* ── Product Page ─────────────────────────────────────────── */
  function initProductPage() {
    if (!document.querySelector('.dbyz-product')) return;

    // ── Image gallery
    var images = Array.from(document.querySelectorAll('[data-src]'));
    var featuredImg = document.getElementById('dbyz-featured-img');
    var currentIdx = 0;

    function switchImage(idx) {
      if (!featuredImg || !images.length) return;
      currentIdx = idx;
      var src = images[idx] ? images[idx].dataset.src : null;
      if (src) {
        featuredImg.style.opacity = '0';
        setTimeout(function () {
          featuredImg.src = src;
          featuredImg.style.opacity = '1';
        }, 200);
      }
      // Update counter
      var counter = document.getElementById('dbyz-img-current');
      if (counter) counter.textContent = idx + 1;
      // Update thumb active state
      document.querySelectorAll('.dbyz-product__thumb').forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
      });
    }

    // Thumbnail clicks
    document.querySelectorAll('.dbyz-product__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchImage(parseInt(this.dataset.index));
      });
    });

    // Arrow buttons
    var prevBtn = document.getElementById('dbyz-img-prev');
    var nextBtn = document.getElementById('dbyz-img-next');
    if (prevBtn) prevBtn.addEventListener('click', function () {
      switchImage((currentIdx - 1 + images.length) % images.length);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      switchImage((currentIdx + 1) % images.length);
    });

    // Keyboard arrows
    document.addEventListener('keydown', function (e) {
      if (!document.querySelector('.dbyz-product')) return;
      if (e.key === 'ArrowLeft') switchImage((currentIdx - 1 + images.length) % images.length);
      if (e.key === 'ArrowRight') switchImage((currentIdx + 1) % images.length);
    });

    // ── Size selector + variant switching
    var sizeButtons = document.querySelectorAll('.dbyz-size-btn');
    var variantInput = document.getElementById('dbyz-variant-id');
    var priceEl = document.getElementById('dbyz-price');
    var atcBtn = document.getElementById('dbyz-atc-btn');
    var atcLabel = document.getElementById('dbyz-atc-label');

    // Store Shopify variants data on the page
    var productData = null;
    var productDataEl = document.getElementById('dbyz-product-json');
    if (productDataEl) {
      try { productData = JSON.parse(productDataEl.textContent); } catch (e) {}
    }

    var selectedOptions = {};

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionIdx = parseInt(this.dataset.optionIndex);
        var value = this.dataset.value;

        // A crossed-out (sold out) size opens the "notify me" form instead of being selected
        if (this.classList.contains('is-sold')) {
          openNotify(value);
          return;
        }

        // Update UI — deselect siblings
        document.querySelectorAll('.dbyz-size-btn[data-option-index="' + optionIdx + '"]')
          .forEach(function (b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        document.querySelectorAll('.dbyz-size-btn[data-option-index="' + optionIdx + '"]')
          .forEach(function (b) { b.style.borderBottom = '2px solid transparent'; b.style.fontWeight = '400'; });
        this.style.borderBottom = '2px solid #000'; this.style.fontWeight = '700';
        var sizeNameEl = this.closest('.dbyz-product__option').querySelector('#dbyz-size-name');
        if (sizeNameEl) sizeNameEl.textContent = value;

        selectedOptions[optionIdx] = value;

        // Find matching variant if we have product data
        if (productData) {
          var matched = productData.variants.find(function (v) {
            return Object.keys(selectedOptions).every(function (i) {
              return v['option' + (parseInt(i) + 1)] === selectedOptions[i];
            });
          });
          if (matched) {
            if (variantInput) variantInput.value = matched.id;
            // Update price
            if (priceEl) {
              // Same format as the page: "Rs 4,999" (decimals only if the price has cents)
              var units = matched.price / 100;
              var shown = units % 1 === 0
                ? units.toLocaleString('en-US')
                : units.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              priceEl.textContent = (priceEl.dataset.moneyPrefix || '') + shown;
            }
            var stockEl = document.getElementById('dbyz-size-stock');
            if (stockEl) stockEl.textContent = matched.available ? 'In Stock' : 'Sold out';
            // Update ATC state
            if (atcBtn && atcLabel) {
              if (matched.available) {
                atcBtn.disabled = false;
                atcLabel.textContent = 'Add to Bag';
              } else {
                atcBtn.disabled = true;
                atcLabel.textContent = 'Sold Out';
              }
            }
          }
        }
      });
    });

    // ── Quantity stepper
    var qtyInput = document.getElementById('dbyz-qty-input');
    var qtyMinus = document.getElementById('dbyz-qty-minus');
    var qtyPlus  = document.getElementById('dbyz-qty-plus');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value) || 1;
        if (v < 10) qtyInput.value = v + 1;
      });
    }

    // ── ATC AJAX
    var form = document.querySelector('.dbyz-product__form');
    var feedback = document.getElementById('dbyz-atc-feedback');

    if (form && atcBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Validate size selected
        var hasSizes = document.querySelectorAll('.dbyz-size-btn').length > 0;
        var hasSelected = document.querySelector('.dbyz-size-btn.is-selected');
        if (hasSizes && !hasSelected) {
          showFeedback('Please select a size', 'error');
          // Shake size buttons
          document.querySelector('.dbyz-product__option-values').classList.add('dbyz-shake');
          setTimeout(function () {
            document.querySelector('.dbyz-product__option-values').classList.remove('dbyz-shake');
          }, 500);
          return;
        }

        var variantId = variantInput ? variantInput.value : null;
        var qty = qtyInput ? parseInt(qtyInput.value) : 1;
        if (!variantId) { showFeedback('Please select options', 'error'); return; }

        atcBtn.classList.add('dbyz-product__atc--loading');
        atcLabel.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          atcBtn.classList.remove('dbyz-product__atc--loading');
          if (data.status === 422 || data.description) {
            atcLabel.textContent = 'Add to Bag';
            showFeedback(data.description || 'Could not add to bag', 'error');
          } else {
            atcLabel.textContent = '✓ Added to Bag';
            showFeedback('Added to your bag', 'success');
            updateCartCount();
            if (window.dbyzCart) window.dbyzCart.refreshAndOpen();
            setTimeout(function () { atcLabel.textContent = 'Add to Bag'; }, 2500);
          }
        })
        .catch(function () {
          atcBtn.classList.remove('dbyz-product__atc--loading');
          atcLabel.textContent = 'Add to Bag';
          showFeedback('Something went wrong', 'error');
        });
      });
    }

    function showFeedback(msg, type) {
      if (!feedback) return;
      feedback.textContent = msg;
      feedback.className = 'dbyz-product__atc-feedback ' + type;
      setTimeout(function () {
        feedback.textContent = '';
        feedback.className = 'dbyz-product__atc-feedback';
      }, 3500);
    }

    // ── "Notify me when back in stock" (sold-out size)
    // Sends the request through the store's contact form, so it arrives as an email to the store address.
    var notifyModal = document.getElementById('dbyz-notify-modal');
    var notifyForm = document.getElementById('dbyz-notify-form');
    var notifySize = '';
    var notifyProduct = { title: document.title, url: location.href };
    try { notifyProduct = JSON.parse(document.getElementById('dbyz-notify-product').textContent); } catch (e) {}

    function openNotify(size) {
      if (!notifyModal) return;
      notifySize = size;
      var what = document.getElementById('dbyz-notify-what');
      if (what) what.textContent = 'Size ' + size + ' of ' + notifyProduct.title + ' is sold out. Leave your email and we will let you know if it comes back.';
      var msg = document.getElementById('dbyz-notify-msg'); if (msg) msg.textContent = '';
      notifyModal.classList.add('is-open'); notifyModal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
      var em = document.getElementById('dbyz-notify-email'); if (em) setTimeout(function () { em.focus(); }, 250);
    }
    function closeNotify() {
      if (!notifyModal) return;
      notifyModal.classList.remove('is-open'); notifyModal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    }
    var notifyClose = document.getElementById('dbyz-notify-close');
    var notifyBackdrop = document.getElementById('dbyz-notify-backdrop');
    if (notifyClose) notifyClose.addEventListener('click', closeNotify);
    if (notifyBackdrop) notifyBackdrop.addEventListener('click', closeNotify);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNotify(); });

    if (notifyForm) {
      notifyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var msgEl = document.getElementById('dbyz-notify-msg');
        var btn = notifyForm.querySelector('button[type="submit"]');
        document.getElementById('dbyz-notify-body').value =
          'Back-in-stock request\nProduct: ' + notifyProduct.title + '\nSize: ' + notifySize + '\nLink: ' + notifyProduct.url;
        if (btn) btn.disabled = true;
        fetch(notifyForm.action, { method: 'POST', body: new FormData(notifyForm), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) {
            if (/challenge/.test(r.url)) { notifyForm.submit(); return; } // Shopify wants a captcha: fall back to a normal submit
            if (!r.ok) throw new Error('failed');
            if (msgEl) { msgEl.className = 'dbyz-notify__msg success'; msgEl.textContent = 'Thanks! We will email you if size ' + notifySize + ' is back in stock.'; }
            notifyForm.querySelector('#dbyz-notify-email').value = '';
            setTimeout(closeNotify, 2600);
          })
          .catch(function () {
            if (msgEl) { msgEl.className = 'dbyz-notify__msg error'; msgEl.textContent = 'Something went wrong. Please try again or email us.'; }
          })
          .then(function () { if (btn) btn.disabled = false; });
      });
    }

    // ── Size guide modal
    var modal = document.getElementById('dbyz-size-modal');
    var openBtn  = document.getElementById('dbyz-size-guide-open');
    var closeBtn = document.getElementById('dbyz-size-modal-close');
    var backdrop = document.getElementById('dbyz-modal-backdrop');

    function openModal()  { if (modal) { modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; } }
    function closeModal() { if (modal) { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }

    if (openBtn)  openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }

  /* ── Accordion ────────────────────────────────────────────── */
  function initAccordion() {
    document.querySelectorAll('.dbyz-acc-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.dbyz-acc-item');
        var icon = this.querySelector('.dbyz-acc-icon');
        var isOpen = item.classList.contains('is-open');

        // Close all
        document.querySelectorAll('.dbyz-acc-item').forEach(function (i) {
          i.classList.remove('is-open');
          var ic = i.querySelector('.dbyz-acc-icon');
          if (ic) ic.textContent = '+';
          i.querySelector('.dbyz-acc-head').setAttribute('aria-expanded', 'false');
        });

        // Open clicked if it was closed
        if (!isOpen) {
          item.classList.add('is-open');
          if (icon) icon.textContent = '−';
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Cart Page ────────────────────────────────────────────── */
  function initCartPage() {
    if (!document.querySelector('.dbyz-cart')) return;

    var loadingEl = document.getElementById('dbyz-cart-loading');

    function showLoading() { if (loadingEl) loadingEl.classList.add('is-active'); }
    function hideLoading() { if (loadingEl) loadingEl.classList.remove('is-active'); }

    // Qty change + remove buttons
    document.querySelectorAll('.dbyz-cart-qty-change').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key    = this.dataset.key;
        var change = this.dataset.change;

        if (change === 'remove') {
          updateCartItem(key, 0);
          return;
        }

        // Get current qty display
        var item = this.closest('.dbyz-cart-item');
        var display = item.querySelector('.dbyz-qty__display');
        var currentQty = parseInt(display ? display.textContent : 1) || 1;
        var newQty = currentQty + parseInt(change);
        if (newQty < 1) { updateCartItem(key, 0); return; }
        updateCartItem(key, newQty);
      });
    });

    function updateCartItem(key, qty) {
      showLoading();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        hideLoading();
        if (qty === 0) {
          // Remove item from DOM
          var itemEl = document.querySelector('.dbyz-cart-item[data-key="' + key + '"]');
          if (itemEl) {
            itemEl.style.opacity = '0';
            itemEl.style.transform = 'translateX(-20px)';
            itemEl.style.transition = 'opacity .3s, transform .3s';
            setTimeout(function () { itemEl.remove(); }, 300);
          }
        } else {
          // Update qty display
          var itemEl = document.querySelector('.dbyz-cart-item[data-key="' + key + '"]');
          if (itemEl) {
            var display = itemEl.querySelector('.dbyz-qty__display');
            if (display) display.textContent = qty;
          }
        }
        // Update totals
        updateCartTotals(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () { hideLoading(); });
    }

    function updateCartTotals(cart) {
      var subtotalEl = document.getElementById('dbyz-subtotal');
      var totalEl    = document.getElementById('dbyz-total');
      if (!subtotalEl && !totalEl) return;

      // Format money
      var total = formatMoney(cart.total_price);
      if (subtotalEl) subtotalEl.textContent = total;
      if (totalEl)    totalEl.textContent    = total;

      // Update checkout button label
      var checkoutBtn = document.querySelector('.dbyz-cart__checkout span');
      if (checkoutBtn) checkoutBtn.textContent = 'Checkout — ' + total;

      // Update item count
      var countEl = document.querySelector('.dbyz-cart__item-count');
      if (countEl) {
        countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'piece' : 'pieces');
      }

      // If cart is empty, reload to show empty state
      if (cart.item_count === 0) {
        setTimeout(function () { window.location.reload(); }, 400);
      }
    }

    function formatMoney(cents) {
      var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'AUD';
      return currency + ' $' + (cents / 100).toFixed(2);
    }

    // Note toggle
    var noteToggle = document.getElementById('dbyz-note-toggle');
    var noteArea   = document.getElementById('dbyz-note-area');
    var noteArrow  = document.getElementById('dbyz-note-arrow');
    var noteHidden = document.getElementById('dbyz-note-hidden');
    var noteInput  = document.getElementById('dbyz-cart-note');

    if (noteToggle && noteArea) {
      noteToggle.addEventListener('click', function () {
        var isVisible = noteArea.style.display !== 'none';
        noteArea.style.display = isVisible ? 'none' : 'block';
        if (noteArrow) noteArrow.textContent = isVisible ? '+' : '−';
      });
    }

    // Sync note to hidden input on checkout
    if (noteInput && noteHidden) {
      noteInput.addEventListener('input', function () {
        noteHidden.value = this.value;
      });
    }
  }

  /* ── Cart count helper ────────────────────────────────────── */
  function updateCartCount(count) {
    if (typeof count === 'undefined') {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCartCountEl(cart.item_count); });
    } else {
      setCartCountEl(count);
    }
  }

  function setCartCountEl(count) {
    var el = document.getElementById('dbyz-cart-count');
    // The header markup already wraps this span in "( )", so write the bare number.
    if (el) el.textContent = count;
  }

  /* ── Shake animation CSS inject ──────────────────────────── */
  function injectShakeCSS() {
    var style = document.createElement('style');
    style.textContent = [
      '@keyframes dbyz-shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-6px)}40%{transform:translateX(6px)}60%{transform:translateX(-4px)}80%{transform:translateX(4px)}}',
      '.dbyz-shake{animation:dbyz-shake .4s cubic-bezier(.36,.07,.19,.97) both}'
    ].join('');
    document.head.appendChild(style);
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    injectShakeCSS();
    initProductPage();
    initAccordion();
    initCartPage();
  });

})();


/* Menu bar: hide on scroll down, show on scroll up */
(function () {
  var lastY = window.pageYOffset || 0, ticking = false;
  function update() {
    ticking = false;
    var y = window.pageYOffset || 0;
    if (document.body.style.overflow === 'hidden') { lastY = y; return; } /* menu / drawer / modal open */
    if (y <= 60) document.body.classList.remove('nav-hidden');
    else if (y > lastY + 6) document.body.classList.add('nav-hidden');
    else if (y < lastY - 6) document.body.classList.remove('nav-hidden');
    lastY = y;
  }
  window.addEventListener('scroll', update, { passive: true });
})();
